module.exports = __webpack_public_path__ + "img/F969.500d4923.jpg";